<template>
  <div class="container">
    <el-carousel
      height="470px"
      :interval="5000"
      arrow="always"
      trigger="click"
    >
      <el-carousel-item
        v-for="(item,index) in bannerList"
        :key="index"
      >
        <img class="banner-img" :src="item.img" alt="banner" />
      </el-carousel-item>
    </el-carousel>

  </div>
</template>

<script>
export default {
  name: "Banner",
  data(){
    return{
    }
  },
  props: {
    bannerList: {
      type: Array,
    }
  }
}
</script>

<style scoped>
.container{
  margin: 0;
  padding: 0;
}
.container >>> .el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  opacity: .48;
}
.container{
  clear: both;
}
.container >>> .is-active .el-carousel__button {
  opacity: 1;
}

.container >>> .el-carousel__arrow {
  width: 40px;
  height: 40px;
  font-size: 30px;
}

.banner-img {
  height: 470px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue